<template>
  <b-container v-if="!loading" class="d-flex flex-column h-100" fluid>
    <b-card body-class="py-0 px-0" class="border-0 mb-0">
      <b-nav class="nav-base">
        <b-nav-item :to="{ name: 'users' }">
          <b-icon class="mr-1" icon="person-square" />
          Užívatelia
        </b-nav-item>
        <b-nav-item :to="{ name: 'companies' }">
          <b-icon class="mr-1" icon="building" />
          Spoločnosti
        </b-nav-item>
        <b-nav-item :to="{ name: 'pricelist' }">
          <b-icon class="mr-1" icon="cash-stack" />
          Cenníky
        </b-nav-item>
        <b-nav-item :to="{ name: 'userlogs' }">
          <b-icon class="mr-1" icon="card-checklist" />
          Prehľad prihlásení
        </b-nav-item>
        <b-nav-item :to="{ name: 'settingsApi' }">
          <b-icon class="mr-1" icon="shuffle" />
          API: Intervalové data
        </b-nav-item>
        <b-nav-item :to="{ name: 'settingsDowntime' }">
          <b-icon class="mr-1" icon="wrench" />
          Plánované odstávky
        </b-nav-item>
      </b-nav>
    </b-card>
    <b-row class="flex-grow-1" style="min-height: 1px">
      <transition name="fadeDownShort" mode="out-in">
        <router-view :key="$route.params.id" />
      </transition>
    </b-row>
  </b-container>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
    }
  },
}
</script>
